export const DigitalIDs = {
  "Title": "Digital IDs",
  "Actions": {
    "AddID": "Add ID",
    "CertificateDetails": "Certificate Details",
    "Export": "Export",
    "Refresh": "Refresh",
    "RemoveID": "Remove ID"
  },
  "Table": {
    "Name": "Name",
    "Issuer": "Issuer",
    "StorageMechanism": "Storage Mechanism",
    "Expires": "Expires"
  },
  "Details": {
    "Name": "Name",
    "Issuer": "Issuer",
    "ValidFrom": "Valid from",
    "ValidTo": "Valid to",
    "IntendedKeyUsage": "Intended key usage"
  },
  "Popup": {
    "Remove": "Are you sure you want to delete the selected digital ID?"
  },
  "StorageMechanism": {
    "DigitalIDFile": "Digital ID File"
  }
}